module.exports = __webpack_public_path__ + "img/miguayanwobing.dfaaa5df.jpg";